import { Directive } from '@angular/core';

@Directive({
  selector: '[appVwPbCreateLabelForm]',
  standalone: true,
})
export class PackingBoxCreateLabelFormDirective {
  constructor() {}
}
